import { Subscription } from 'rxjs/Subscription';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { DomAdapter, getDOM } from '@angular/platform-browser/src/dom/dom_adapter';
import { Router } from "@angular/router";

import { TemplateService } from './services/settings/template.service';
import { CacheService } from './services/core/cache.service';
import { Mappings } from './shared/mapping';
import { RoutesService } from "./services/core/routes.service";
import { Breadcrumbs } from "./models/cms/breadcrumbs";

import {
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { ComponentHelperService } from './services/core/component-helper.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app',
  template:require('./app.component.html')
})

export class AppComponent {

  private _dom: DomAdapter = getDOM();
  
  constructor(private template: TemplateService,
    @Inject(DOCUMENT) private document: any,
    @Inject('isNode') private isNode: boolean,
    private cache: CacheService,
    private mappings: Mappings,
    private router: Router,
    public routesService: RoutesService
  ) {
      let sub = router.events.subscribe((event: RouterEvent) => {
        this.navigationInterceptor(event)
      });

      this.subManager.add(sub);
  }

  subManager = new Subscription();
  
  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.routesService.showPageLoader();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.routesService.hidePageLoader();      
    }
    
    if (event instanceof NavigationError) {
      this.routesService.hidePageLoader();      
    }
  }

  ngOnInit() {
    if (!this.isNode) {
      return;
    }

    let templateSub = this.template.getHeadFootData()
        .subscribe((headFootData) => {
        //Dynamically adding head css, js to the page (head.html)
        this.appendHtmlString(this.document.head, headFootData.HeadTemplateHtml);

        //Dynamically adding head css, js to the page (foot.html)
        this.appendHtmlString(this.document.body, headFootData.FootTemplateHtml);
      });

      this.subManager.add(templateSub);
  }

  private appendHtmlString(el: any, template: string) {
    let div = this._dom.createElement('div');
    this._dom.setInnerHTML(div, template);
    this._dom.insertAllBefore(el.lastChild, this._dom.childNodes(div));
  }

  clearMemory(){
    this._dom = null;
    this.subManager.unsubscribe();
    this.cache.clearAll();
    this.document = null;
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.clearMemory();
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/app.component.ts